module.exports = __webpack_public_path__ + "static/010-ad5b2b431c35498d364187d3ed97ce86.jpg";